import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UserProfile} from '@shared/models/user-profile.model';
import {Subscription} from 'rxjs';
import {PatientService} from '@shared/services/patient.service';
import {CircleService} from '@shared/services/circle.service';
import {LoaderService} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';
import {CircleAuthorization} from '@shared/models/circle-authorization.model';
import {LoginService} from '@shared/services/login.service';
import {Session} from '@shared/models/session.model';
import {PermissionService} from '@shared/services/permission.service';
import {patientRoles} from '@shared/constants/patient.constants';

@Component({
  selector: 'si-patient-bar',
  templateUrl: './patient-bar.component.html',
  styleUrls: ['./patient-bar.component.scss']
})
export class PatientBarComponent implements OnInit, OnDestroy {
  @Input() styleClass: string;
  currentPatient: UserProfile;
  accountUser: UserProfile;
  patientCircle: CircleAuthorization[];
  currentPatientAuthorization: CircleAuthorization;
  userSession: Session;
  isAccountUser: boolean = null;
  patientRoles = patientRoles;
  private patientSubscription: Subscription;

  constructor(
    private patientService: PatientService,
    private loaderService: LoaderService,
    private loginService: LoginService,
    private circleService: CircleService,
    private permissionService: PermissionService,
  ) {
  }

  ngOnInit(): void {
    this.getCircleAuthorizations();
    this.userSession = this.loginService.getSession();
    this.patientSubscription = this.patientService.getPatientObservable().subscribe(data => {
      this.currentPatient = data.patient;
      this.accountUser = data.accountUser;
      this.getCircleAuthorizations();
    });
  }

  async getCircleAuthorizations(): Promise<void> {
    try {
      this.loaderService.start();
      if (this.permissionService.hasPermission('my_circle:get_authorized_by')) {
        this.patientCircle = await this.circleService.getAuthorizationsByAccepted();
      }
    } finally {
      this.getCurrentPatientAuthorization();
      this.loaderService.stop();
    }
  }

  getCurrentPatientAuthorization(): void {
    this.currentPatientAuthorization = this.patientCircle?.find(auth => auth.patientName === this.getCurrentPatientFullName());
    this.isAccountUser = !this.currentPatientAuthorization;
  }

  getCurrentPatientFullName(): string {
    const fullName = [
      this.currentPatient?.personalData?.firstName,
      this.currentPatient?.personalData?.surname1,
      this.currentPatient?.personalData?.surname2
    ].filter(Boolean); // deletes undefined, null, ''.

    return fullName.join(' ');
  }

  ngOnDestroy() {
    if (this.patientSubscription) {
      this.patientSubscription.unsubscribe();
    }
  }
}
